import type { ConditionBuildableId } from "@skilitics/nautilus-core-designer-data";

import type { DesignerCondition } from "../../types/index.ts";
import { GROUP_CONDITION_NAME, NEGATION_CONDITION_NAME, TYPE_DROPPABLE } from "../constants.ts";

export const makeBuildableKey = ({ name, nodeId }: ConditionBuildableId) => `${nodeId}:${name}`;

export const isConditionAllowedChildren = ({ builder }: DesignerCondition) =>
  builder.typeId === GROUP_CONDITION_NAME || builder.typeId === NEGATION_CONDITION_NAME;

export const makeConditionDroppableId = (id: number) => `${TYPE_DROPPABLE}:${id}`;

export const parseConditionDroppableId = (droppableId: `${typeof TYPE_DROPPABLE}:${number}`): number => {
  const [_, idStr] = droppableId.split(":");
  return Number(idStr);
};
